"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/juomat/juomat.scss');
const index_1 = require("./../js/index");
const juomat_1 = require("./Sites/juomat");
const ProductsApp_juomat_1 = require("./ReactComponents/Products/ProductsApp-juomat");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import site specific scripts
(0, juomat_1.InitJuomat)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)(Object.assign(Object.assign({}, index_1.DefaultComponentTypes), { ProductsApp: ProductsApp_juomat_1.default }));
